import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import i18n from 'i18next'
import Column from '~/Common-Objects/Grids/Column/Column'
import Dialog from '~/Common-Objects/UI/Dialog'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Row from '~/Common-Objects/Grids/Row/Row'
import axios from '~/data/http/axios'
import Theme from '~/pages/cp/templates/add/dragDropV2/themes/theme'
import PopPreviewTheme from '~/pages/cp/templates/add/dragDropV2/themes/popPreviewTheme'
import { useHistory } from 'react-router-dom'
import { canUseAiTemplateBuilder } from '~/utils/aiTemplateBuilder'
import AiCreateWizard from '~/pages/cp/includes/aiCreateWizard'

export default function LandingPagePicker({ themeName = '', onCancel, onComplete = () => {} }) {
    const history = useHistory()
    const accountMaster = useSelector((state) => state.accountMaster)
    const siteMaster = useSelector((state) => state.siteMaster)
    const showAiGenerate = canUseAiTemplateBuilder(accountMaster, siteMaster)
    const [themes, setThemes] = useState([])
    const [loading, setLoading] = useState(true)
    const [previewTheme, setPreviewTheme] = useState(false)
    const [selectedTheme, setSelectedTheme] = useState(null)
    const [scratchMode, setScratchMode] = useState(false)

    useEffect(() => {
        getLandingPages()
    }, [])

    const getLandingPages = async () => {
        const response = await axios.get('/theme?type=10&limit=50')
        setThemes(response.data.Themes)
        setLoading(false)
    }

    const selectTheme = async (themeId) => {
        const response = await axios.post('/landingpage/', {
            themeId: themeId,
            name: themeName && String(themeName).trim().length >= 4 ? String(themeName).trim() : 'New landing page'
        })
        const editorUrl = '/cp/templates/add/dragDropv2/' //only supported in v2 editor
        history.push(editorUrl + '?landingPageId=' + response.data.id)
    }

    const onPreviewTheme = (event, theme) => {
        event.preventDefault()
        event.stopPropagation()
        setPreviewTheme(true)
        setSelectedTheme(theme)
    }

    if (showAiGenerate && !scratchMode) {
        return (
            <AiCreateWizard
                kind='landing'
                history={history}
                landingName={themeName}
                onStartFromScratch={() => setScratchMode(true)}
                onCancel={onCancel}
            />
        )
    }

    if (loading) return <LoadingIcons iconType='2' />

    return (
        <div>
            <h4 className='mar-b15'>{i18n.t('form:landingPages.add.themePicker.header')}</h4>
            <div className='mar-b25'>{i18n.t('form:landingPages.add.themePicker.subHeader')}</div>
            {themes.length > 0 && (
                <Row>
                    {themes.map((theme, index) => {
                        return (
                            <Column xs={12} sm={6} md={4} lg={4} className='themes-advanced' key={index}>
                                <Theme
                                    theme={theme}
                                    className='extraSpace'
                                    select={() => {
                                        selectTheme(theme.id)
                                    }}
                                    preview={(event) => onPreviewTheme(event, theme)}
                                />
                            </Column>
                        )
                    })}
                </Row>
            )}
            {previewTheme && (
                <Dialog.Root open={true}>
                    <Dialog.Portal>
                        <Dialog.Overlay />
                        <Dialog.Content
                            style={{
                                width: '100vw',
                                height: '100vh',
                                maxWidth: '100vw',
                                maxHeight: '100vh',
                                top: 0,
                                borderRadius: 0
                            }}
                        >
                            <PopPreviewTheme
                                theme={selectedTheme}
                                selectTemplate={() => selectTheme(selectedTheme.id)}
                                closePreview={() => setPreviewTheme(false)}
                                landingPage={true}
                            />
                        </Dialog.Content>
                    </Dialog.Portal>
                </Dialog.Root>
            )}
        </div>
    )
}
